import Strings from "../strings/strings";

export default function () {
  return <>{Strings.noPage}</>;
}
